// extracted by mini-css-extract-plugin
module.exports = {"section":"HorizontalMenu_section__sRjR7","nameMenu":"HorizontalMenu_nameMenu__mukQV","pipeSymbol":"HorizontalMenu_pipeSymbol__5OECO"};